import { Flex } from "antd";
import { StatusBadge } from "pages/schedule/component/ScheduleStatusBadge";
import { PackageAnalyticsRow } from "shared/types";
import { productStatusChip } from "shared/utils";

type StatusRow = Pick<PackageAnalyticsRow, "is_promo" | "promo_active" | "promo_starts_at" | "is_deleted">;

// A product report row's status chip: "Promo · Active / Upcoming / Ended",
// "Discontinued" for a tier deleted from the catalogue that the report still
// lists for its sales or usage (System Review N7 / N10), or
// "Promo · Discontinued" (see productStatusChip). Fixed English in both
// languages like every status word; the PDF prints the same words under the
// name and the Excel puts Discontinued in its Status column.
export const ProductStatusTag = ({ row }: { row: StatusRow }) => {
  const chip = productStatusChip(row);
  return chip ? <StatusBadge tone={chip.tone} label={chip.label} /> : null;
};

// The product cell of Performa and Pendapatan dari Paket / Membership: the
// name in the catalogue's bold, then the status chip when there is one.
export const ProductNameCell = ({ row }: { row: PackageAnalyticsRow }) =>
  productStatusChip(row) ? (
    <Flex gap={8} align="center" wrap="wrap">
      <span style={{ fontWeight: 600 }}>{row.name}</span>
      <ProductStatusTag row={row} />
    </Flex>
  ) : (
    <span style={{ fontWeight: 600 }}>{row.name}</span>
  );
